module.exports = __webpack_public_path__ + "img/375.418b217a.jpg";